import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Switch, Route, Link } from 'react-router-dom';
import routerCfg from 'routerCfg';
import styles from './style.scss?__local';
import Header from 'ui-header';
import ExtApp from './extApp';
import Home from './home';
import ICenter from './i-center';
import NotFound from './notFound';
import Fee from './fee/index'
import zhCN from 'antd/lib/locale-provider/zh_CN'
import { ConfigProvider, Row, Col } from 'antd';
import yaReport from '@huyafed/ya-report'
import smoothscroll from 'smoothscroll-polyfill'
import Protocols from './protocols'

smoothscroll.polyfill()

function App() {
  return (
    <Router>
      <ConfigProvider locale={zhCN}>
        <div className={styles.app}>
          <div className={styles['app-hd']}>
            <Header />
          </div>
          <div className={styles['app-bd']}>
            <Row type="flex" justify="center">
              <Col span={22}>
                <div className={styles['app-content']}>
                  <Switch>
                    <Route exact path={routerCfg.path.app} component={ExtApp} />
                    <Route exact path={routerCfg.path.i} component={ICenter} />
                    <Route exact path={routerCfg.path.home} component={Home} />
                    <Route path={routerCfg.path.fee} component={Fee} />
                    <Route path={routerCfg.path.protocols} component={Protocols} />
                    <Route component={NotFound} />
                  </Switch>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </ConfigProvider>
    </Router>
  )
}

// TODO: 对不支持react的浏览提示更换或升级
function main() {
  ReactDOM.render(<App />, document.getElementById('J_root'))
}

main()


yaReport && yaReport({
  pro: process.env.HUYA_APP_REPORT_PRO,
})
